module.exports = __webpack_public_path__ + "static/media/Edit-Point.0b043317.svg";